import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Image } from "@/components/image";
import { ProductModelDetails } from "@/services/productService";
import "./style.scss";

interface ModelDetailsProps {
  modelProfile: ProductModelDetails;
}

const ModelDetails: FC<ModelDetailsProps> = ({ modelProfile }) => {
  const { height, bust, waist, hips, imageUrl, modelSizeLabel } = modelProfile;
  const { t } = useTranslation("productDetails");

  return (
    <div className="model_info_block">
      <div className="image_block">
        <Image className="image" src={imageUrl} />
      </div>
      <div className="details_block">
        <span className="size_text">
          {t("model.modelSize", { modelSizeLabel })}
        </span>
        <div className="details_text_block">
          <span>{t("model.height", { height })}</span>
          <span>{t("model.bust", { bust })}</span>
          <span>{t("model.waist", { waist })}</span>
          <span>{t("model.hips", { hips })}</span>
        </div>
      </div>
    </div>
  );
};

export default ModelDetails;
